import ScrollArea from "@ui/ScrollArea/ScrollArea";

export default ScrollArea;